import { ai360 } from '../products/ai360.mjs';
import { aiDome } from '../products/aiDome.mjs';
import { aiDslr } from '../products/aiDslr.mjs';
import { aiLpr } from '../products/aiLpr.mjs';
import { aiPro } from '../products/aiPro.mjs';
import { aiPtzIndustrial } from '../products/aiPtzIndustrial.mjs';
import { aiPtzPrecision } from '../products/aiPtzPrecision.mjs';
import { aiTurret } from '../products/aiTurret.mjs';
import { g4Instant } from '../products/g4Instant.mjs';
import { g5Bullet } from '../products/g5Bullet.mjs';
import { g5Dome } from '../products/g5Dome.mjs';
import { g5DomeUltra } from '../products/g5DomeUltra.mjs';
import { g5Flex } from '../products/g5Flex.mjs';
import { g5Pro } from '../products/g5Pro.mjs';
import { g5Ptz } from '../products/g5Ptz.mjs';
import { g5TurretUltra } from '../products/g5TurretUltra.mjs';
import { g6180 } from '../products/g6180.mjs';
import { g6Bullet } from '../products/g6Bullet.mjs';
import { g6Dome } from '../products/g6Dome.mjs';
import { g6Instant } from '../products/g6Instant.mjs';
import { g6Pro360 } from '../products/g6Pro360.mjs';
import { g6Ptz } from '../products/g6Ptz.mjs';
import { g6Turret } from '../products/g6Turret.mjs';
import { aiTheta } from '../products/theta.mjs';
import { aiThetaPro } from '../products/thetaPro.mjs';
"use strict";
const physicalSecurityProducts = [/** Bullet */
g6Bullet, g5Bullet, g5Pro, aiPro, aiDslr, aiLpr, /** Dome & Turret */
g6Dome, g6Pro360, g6180, g6Turret, aiTurret, aiDome, g5DomeUltra, g5TurretUltra, g5Dome, ai360, /** Compact */
g6Instant, g5Flex, g4Instant, /** Interior Design */
aiThetaPro, aiTheta, /** PTZ */
aiPtzPrecision, aiPtzIndustrial, g6Ptz, g5Ptz];
export { physicalSecurityProducts };
//# sourceMappingURL=physicalSecurityProducts.mjs.map
